import DealersDashboard from "./DealersDashboard";

export default DealersDashboard;
